import script from "./DialogRhpk.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogRhpk.vue?vue&type=script&setup=true&lang=ts"

import "./DialogRhpk.vue?vue&type=style&index=0&id=4b1801b7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1801b7"]])

export default __exports__